import { useEffect } from "react";
import { setStage } from "../../store/reducers/stageReducer";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { setStep } from "../../store/reducers/stepReducer";
import { useUpdateStagesMutation } from "../../services/api";
import useHasPermission from "../../hooks/useHasPermission";
import { tracker } from "../../services/mixpanel";

const InceptionPresentation = () => {
  const dispatch = useAppDispatch();
  const [updateStage] = useUpdateStagesMutation();
  const loginData = useAppSelector((state) => state.login);
  const stageData = useAppSelector((state) => state.stage);
  const zohoCustomerId = loginData.zohoCustomerId;
  const { hasPermission } = useHasPermission();
  const next = async () => {
    const newStateData = {
      ...stageData,
      presentationComplete: true,
    };
    dispatch(setStage(newStateData));
    if (hasPermission("benefitCalculator")) {
      dispatch(setStep(4));
    } else {
      dispatch(setStep(5));
    }
    await updateStage({
      zohoId: zohoCustomerId,
      key: "presentationComplete",
    });
  };

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data === "presentationComplete") {
        tracker.steps.presentation.complete();
        next();
      } else if (event.data && event.data.type === "presentationStep") {
        tracker.steps.presentation.step(event.data.step);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [dispatch, stageData, zohoCustomerId]);

  useEffect(() => {
    // tracker.steps.presentation.pageView();
    tracker.steps.presentation.start();
  }, []);

  return (
    <iframe
      src="/InceptionPresentation/index.html"
      style={{ width: "100vw", height: "100vh", border: "none" }}
      title="Inception Presentation"
      id="inceptionIframe"
    ></iframe>
  );
};

export default InceptionPresentation;
